var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathingQual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_9",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#050506;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.39,24.19c0-6.84-4.19-17.73-9.15-17.73-2.94,0-4,2.47-4.37,5.19-.76-.08-.77-.32-.77-.84V5.87A1.9,1.9,0,0,0,18,4.22a1.89,1.89,0,0,0-2.11,1.65v4.94c0,.51,0,.75-.75.84-.37-2.72-1.43-5.19-4.37-5.19-5,0-9.15,10.89-9.15,17.73,0,.21,0,5.3,1.65,6.7a1.59,1.59,0,0,0,1,.39,3.61,3.61,0,0,0,2.21-.76,14.62,14.62,0,0,1,5.12-2.05c5.16-1.23,4.62-5.22,4-9.44-.13-1-.27-2.06-.34-3.1A7.4,7.4,0,0,0,18,15.27a7.25,7.25,0,0,0,2.66.66c-.07,1-.2,2.08-.34,3.1-.57,4.22-1.11,8.21,4.05,9.44a14.62,14.62,0,0,1,5.12,2.05,3.61,3.61,0,0,0,2.21.76,1.59,1.59,0,0,0,1.05-.39C34.42,29.49,34.39,24.4,34.39,24.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingQual);
export default __webpack_public_path__ + "static/media/breathing-qual.3d08b94478bb8c991585cb4dcc73badb.svg";
export { ForwardRef as ReactComponent };